"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actionTypes = _interopRequireDefault(require("../actions/action-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var profileCard = function profileCard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionTypes.default.INITIALIZE_CARD:
      {
        return {
          id: action.payload.profileCardId,
          details: {},
          errorMsg: '',
          isOpen: false
        };
      }

    case _actionTypes.default.SHOW_PROFILE:
      {
        return _objectSpread({}, state, {
          isOpen: true
        });
      }

    case _actionTypes.default.HIDE_PROFILE:
      {
        return _objectSpread({}, state, {
          errorMsg: '',
          isOpen: false
        });
      }

    case _actionTypes.default.PROFILE_FETCHED:
      {
        return _objectSpread({}, state, {
          details: {
            id: action.payload.id,
            name: action.payload.name,
            company: action.payload.company,
            title: action.payload.title,
            level: action.payload.level,
            avatarUrl: action.payload.avatarUrl
          }
        });
      }

    case _actionTypes.default.PROFILE_ERROR:
      {
        return _objectSpread({}, state, {
          errorMsg: action.payload.errorMsg
        });
      }

    case _actionTypes.default.SET_MESSAGE_URL:
      {
        return _objectSpread({}, state, {
          messageUrl: action.payload.messageUrl
        });
      }

    default:
      {
        return state;
      }
  }
};

var _default = profileCard;
exports.default = _default;